import React from "react";
import Logo from "../../assets/logo-high-quality.png";
import whiteLogo from "../../assets/white-logo-highQ.png";
import { Link, NavLink } from "react-router-dom";
import "./navbar.css";

const Navbar = () => {
  const closeOffcanvas = () => {
    const offcanvasElement = document.querySelector("#offcanvasRight");
    if (offcanvasElement) {
      const bsOffcanvas =
        window.bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={Logo} alt="" />
          </Link>
          <button
            className="showNaBtn"
            type=" btn button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M5.77778 32C5.27407 32 4.85215 31.808 4.512 31.424C4.17067 31.0413 4 30.5667 4 30C4 29.4333 4.17067 28.9587 4.512 28.576C4.85215 28.192 5.27407 28 5.77778 28H34.2222C34.7259 28 35.1479 28.192 35.488 28.576C35.8293 28.9587 36 29.4333 36 30C36 30.5667 35.8293 31.0413 35.488 31.424C35.1479 31.808 34.7259 32 34.2222 32H5.77778ZM5.77778 22C5.27407 22 4.85215 21.808 4.512 21.424C4.17067 21.0413 4 20.5667 4 20C4 19.4333 4.17067 18.958 4.512 18.574C4.85215 18.1913 5.27407 18 5.77778 18H34.2222C34.7259 18 35.1479 18.1913 35.488 18.574C35.8293 18.958 36 19.4333 36 20C36 20.5667 35.8293 21.0413 35.488 21.424C35.1479 21.808 34.7259 22 34.2222 22H5.77778ZM5.77778 12C5.27407 12 4.85215 11.8087 4.512 11.426C4.17067 11.042 4 10.5667 4 10C4 9.43333 4.17067 8.958 4.512 8.574C4.85215 8.19133 5.27407 8 5.77778 8H34.2222C34.7259 8 35.1479 8.19133 35.488 8.574C35.8293 8.958 36 9.43333 36 10C36 10.5667 35.8293 11.042 35.488 11.426C35.1479 11.8087 34.7259 12 34.2222 12H5.77778Z"
                fill="black"
              />
            </svg>
          </button>
          <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
          >
            <div className="offcanvas-header">
              <div className="offcanvas-title" id="offcanvasRightLabel">
                <NavLink
                  className="navbar-brand"
                  to="/"
                  onClick={() => {
                    closeOffcanvas();
                    handleClick();
                  }}
                >
                  <img src={whiteLogo} alt="Logo" />
                </NavLink>
              </div>
              <div>
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 14.5551L3.05703 23.4981C2.72243 23.8327 2.29658 24 1.77947 24C1.26236 24 0.836501 23.8327 0.5019 23.4981C0.1673 23.1635 0 22.7376 0 22.2205C0 21.7034 0.1673 21.2776 0.5019 20.943L9.44487 12L0.5019 3.05703C0.1673 2.72243 0 2.29658 0 1.77947C0 1.26236 0.1673 0.836501 0.5019 0.5019C0.836501 0.1673 1.26236 0 1.77947 0C2.29658 0 2.72243 0.1673 3.05703 0.5019L12 9.44487L20.943 0.5019C21.2776 0.1673 21.7034 0 22.2205 0C22.7376 0 23.1635 0.1673 23.4981 0.5019C23.8327 0.836501 24 1.26236 24 1.77947C24 2.29658 23.8327 2.72243 23.4981 3.05703L14.5551 12L23.4981 20.943C23.8327 21.2776 24 21.7034 24 22.2205C24 22.7376 23.8327 23.1635 23.4981 23.4981C23.1635 23.8327 22.7376 24 22.2205 24C21.7034 24 21.2776 23.8327 20.943 23.4981L12 14.5551Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="offcanvas-body">
              <ul className=" links navbar-nav m-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      closeOffcanvas();
                      handleClick();
                    }}
                    className="nav-link"
                    aria-current="page"
                    to="/"
                  >
                    Home
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      closeOffcanvas();
                      handleClick();
                    }}
                    className="active nav-link"
                    aria-current="page"
                    to="/services"
                  >
                    Services
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      // closeOffcanvas();
                      handleClick();
                    }}
                    className="nav-link"
                    aria-current="page"
                    to="/work"
                  >
                    Careers
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      closeOffcanvas();
                      handleClick();
                    }}
                    className="nav-link"
                    aria-current="page"
                    to="/faqs"
                  >
                    FAQ
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      closeOffcanvas();
                      handleClick();
                    }}
                    className="nav-link"
                    aria-current="page"
                    to="/about"
                  >
                    About Us
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    onClick={() => {
                      closeOffcanvas();
                      handleClick();
                    }}
                    className="nav-link"
                    aria-current="page"
                    to="/contact"
                  >
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="links navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/services"
                >
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/work"
                >
                  Careers
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/faqs"
                >
                  FAQ
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/about"
                >
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={handleClick}
                  className={({ isActive }) =>
                    isActive ? "nav-link active-link" : "nav-link"
                  }
                  aria-current="page"
                  to="/contact"
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
